import { ChangeDetectorRef, Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { WIZ_BOOLEAN, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  PopUpManager,
  WizPopUp,
  WizEventManager,
  WizTranslationManager,
  WizEvent,
  WizTextInput,
  WizCheckbox
} from '@wizeoo/akm-component-lib';
import { DATA_KIND, FIELD_KIND, FeiKeyDef, WizConstants } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

import { IWidget, IWidgetFilter } from '../../../../../manager/widgets/i-widget';
import { ViewData } from '../../../../../model/view.data';
import { ComparatorVO } from '../../../../../vo/common/tool/comparator.vo';
import { ChronocodeVO } from '../../../../../vo/core/chronocode.vo';
import { FreeDataVO } from '../../../../../vo/core/freedata.vo';
import { FreedataArgsVO } from  '../../../../../vo/core/freedataargs.vo';
import { FreedataValueVO } from  '../../../../../vo/core/freedatavalue.vo';
import { Model } from '../../../../../model/model';
import { PopUtils } from '../../../../../framework/components/pop/pop-utils';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE, WIDGET_GLOBAL_KIND } from '../../../../../model/enums';
import { ScenarioVO } from '../../../../../vo/scenarii/scenario.vo';

import { filterPopData, PivotFilterExtendedPop } from './pivot-filter-extended.pop';
import { PivotScenExtendedPop } from './pivot-scen-extended.pop';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { WidgetEngine } from '../../../../../manager/widgets/widget.engine';

/**
 * rendu d'un filtre de pivot
 */
@Component({
  selector: 'pivot-filter-extended-renderer',
  templateUrl: './pivot-filter-extended.renderer.html',
})
export class PivotFilterExtendedRenderer implements IWizItemRenderer<WidgetConfigurationItemObj, IWidgetFilter> {
  @HostBinding('style.width.px') get elwidth(): number {
    return this.goodWidth;
  }
  @HostBinding('style.min-width.px')  get elminwidth(): number {
    return this.goodWidth;
  }
  
  /**
   * prise de la taille en fonction du type
   */
  private get goodWidth(): number  {

    let res: any = WidgetEngine.BASIC_FILTER_SIZE;
    if(this.wcio.csiz) {
      res = this.wcio.csiz;
      // console.log('specif', res);
    } else if(!!this.isMeFilter) {
      res = WidgetEngine.ME_FILTER_SIZE;
    }
    else if(!!this.isFreeFilter) {
      res = WidgetEngine.FREE_FILTER_SIZE;
    } else if(this.data.onBoolean) {
      res = WidgetEngine.ME_FILTER_SIZE;
    }

    return res;
  }


  public get contentGoodWidth(): number {
    return this.goodWidth - 20;
  }

  // @HostBinding('style.min-width') elminwidth: string = '180px';
  // @HostBinding('style.max-width') elmaxwidth: string = '180px';
  @HostBinding('style.height') elheight: string = '40px';
  // @ViewChild('filterNameLbl', { read: WizLabel }) filterNameLbl: WizLabel;
  // @ViewChild('filterContentLbl', { read: WizLabel }) filterContentLbl: WizLabel;
  @ViewChild('tiFree', { read: WizTextInput }) tiFree: WizTextInput;
  @ViewChild('cbMe', { read: WizCheckbox, static: false }) cbMe: WizCheckbox;
  @ViewChild('cbBool', { read: WizCheckbox, static: false }) cbBool: WizCheckbox;
  @ViewChild('block') block: ElementRef;

  /** filter masqué */
  @HostBinding('class.invisible-class') get isHidden(): boolean {
    if (this.data?.widget?.templatingMode) {
      return false;
    }

    return !!this.data?.wcio?.filtHide; // filtre masqué
  }


  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  owner: null;

  private _data: IWidgetFilter; // le filtre symbolique
  public get data(): IWidgetFilter {
    return this._data;
  }
  public set data(value: IWidgetFilter) {
    this._data = value;
    this.feedDatas();
  }

  private get model(): Model { // le widget source
    return this.widget?.model;
  }
  
  private get widget(): IWidget { // le widget source
    return this.data?.widget;
  }
  
  private  get wcio(): WidgetConfigurationItemObj { // le contexte pour ce filtre
    return this.data?.wcio;
  }
  private get pkd(): FeiKeyDef { // la pkd liée
    return this.data?.fkd;
  }

  /** libellé du filtre */
  public get filterNameLbl(): string {
    // le label de la combo
    let baseLabel: string;
    if(this.isFreeFilter) {
     baseLabel = WizTranslationManager.getInstance().translateKey('$.common.free.filter.$');
    } else if(this.isMeFilter) {
     baseLabel = WizTranslationManager.getInstance().translateKey('$.common.free.filter.me.$');
    } else if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) {
      baseLabel = this.arg?.trsLabel;
    } else {
      baseLabel = this.model.feiEngine.getFeiKeyDefLabel(this.pkd); 
    }
    if(!!this.wcio.lbl) {
      baseLabel = this.wcio.lbl;
    }
    return baseLabel;
  }

  /** libellé du filtre */
  public get filterContentLbl(): string {
    // le label de la combo
    let baseLabel: string;
    if (this.data.active) {
      // console.log('feed active', this.pkd.fullCode, this.data.active);
      baseLabel = this.getTrueLabel();
      // this.filterContentLbl.tooltipText = this.getTrueLabel(50);
    } else {
      // console.log('feed inactive', this.pkd.fullCode, this.data.active);
      baseLabel = ' '; // pour forcer le refresh
    }
    return baseLabel;
  }




  private datakind: string = null;
  
  private otherField: string = null; // le champ de rendu du FD
  private useNonUniqueField: boolean = false; // le champ demandé n'est pas unique (code, shortCode ou Label)
  private useSubFilter: boolean = false; // on utilise un sous-champ objet pour un FDV

  private freedata: FreeDataVO = null;
  private argMap: Map<string, FreedataArgsVO> = null; // dans le cas d'un filtre sur les FDGrid, mémorisation de la map d'args
  private arg: FreedataArgsVO = null;



  // filtre générique
  public get isFreeFilter(): boolean {
    let res: boolean = false;
    if(this.wcio.cod === ViewData.FILTER_GENERIC) {
      res = true;
    }
    return res;
  }

  public get freeFilterValue(): string {
    // let res: string =  null;
    return this.wcio?.sel?.replaceAll(ViewData.KEY_SEPARATOR, ' ') || null;
    // return res;
  }

  // filtre Me
  public get isMeFilter(): boolean {
    let res: boolean = false;
    if(this.wcio.cod === ViewData.FILTER_ME) {
      res = true;
    }
    return res;
  }

  public get meFilterValue(): boolean {
    let res: boolean = false;
    if(this.wcio?.sel === '1') {
      res = true;
    }
    return res;
  }

  // filtre booléen
  //private _isBoolOK: boolean = false;
  //private _isBoolFilter: boolean = false;
  public get isBoolFilter(): boolean {
    return !!this._data?.onBoolean;
    
    // if(this._isBoolOK) {
    //   return this._isBoolFilter;
    // }
    
    // if(!this.wcio) { // pas encore les données
    //   return false;
    // }

    // let res: boolean = false;
    // if(this.wcio.fmt) {
    //   let parts: string[] = this.wcio.fmt.split(WizConstants.KEY_SEPARATOR);
    //   let format: FormatVO = Model.getInstance().formatEngine.getFormat(parts[0], parts[1]);
    //   if(format?.dataKind === FIELD_KIND.BOOLEAN) {
    //     // console.log("filter boolean by format", this);
    //     res = true;
    //   }
    // }
    // this._isBoolOK = true;
    // this._isBoolFilter = res;
    // return this._isBoolFilter;
  }

  public get boolFilterValue(): WIZ_BOOLEAN {
    let res: WIZ_BOOLEAN = WIZ_BOOLEAN.UNKNOWN;
    if(this.wcio?.sel === '1') {
      res = WIZ_BOOLEAN.TRUE;
    } else if(this.wcio?.sel === '0') {
      res = WIZ_BOOLEAN.FALSE;
    }
    return res;
  }


  feedDatas() {

    this.datakind = this.pkd?.datakind || DATA_KIND.STRING; // prise du type, peut être écrasé par les params de FDs

    if(this.pkd?.isScen) {
      // console.log('chronoFilter', this);
    } else if (this.isFreeFilter || this.isMeFilter) {
      // neutralisation, rien à faire
    } else if(this.pkd.isChrono) {
      // LMA rendu #CHRONO
      if(!!this.wcio.fdvf) { // en cas de surcharge, prise du bon type
        let field: FakeVO = this.widget.model.chronocodeEngine.getChronoFieldByCode(this.wcio.fdvf);
        if(field) {
          this.datakind = field.datakind;
          this.otherField = field.code; // le champ à prendre sur le FDV
        }
      }

      // console.log('chronoFilter', this);
    } else if (this.pkd.isFreedata) {
      const fdParts: string[] = this.wcio.cod.split(ViewData.CONTEXT_SEPARATOR); // on prend le code du FD
      this.freedata = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
      this.argMap = new Map(this.freedata.allFieldsAsArgs.map(item => [item.code, item]));
      
      let realField: string = this.model.widgetEngine.fdvfSplitter(this.wcio.fdvf)[0];
      
      this.arg = this.argMap?.get(realField); // on regarde son args éventuel
      this.datakind = !!this.arg ? this.arg.dataType : FIELD_KIND.STRING; // le type de donnée
      
      this.otherField = realField; // le champ à prendre sur le FDV

      let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
      if(!!realField && uniqueFields.indexOf(realField) === -1) {
        this.useNonUniqueField = true;
      }

      if (this.arg?.dataType === FIELD_KIND.OBJECT) { // c'est un subFD, on écrase le dataKind
        this.useSubFilter = true;
        this.datakind = FIELD_KIND.STRING;
      } 
    }
  }

  /**
   * retourne soit l'expression, soit la liste des valeurs (formatées), soit rien
   */
  public getTrueLabel(maxSize: number = 10): string {
    if (this.data.regex) {
      return this.expAsLabel;
    } else {
      if(!this._selected) {
        this._selected = this.selectedAsLabel;    
      }
      // console.log('getTrueLabel', this.pkd.fullCode, this._selected, this.data.active);
      return this._selected?.slice(0,maxSize).join(WizConstants.STYLE_ELEMENT_SEPARATOR) || ' ';
    }
  }

  // mémorisation pour éviter les calculs inutiles
  private _selected: string[] = null;

  /** retourne les valeurs des éléments sélectionnés sous forme de string, libellé pour rendu */
  public get selectedAsLabel(): string[] {
    let result: string[] = [];
    
    if(this.pkd.isScen) {
      // console.log('scenarFilter', this);
      [...this.data.values].forEach((raw: string) => {
        let scen: ScenarioVO = this.model.scenarioEngine.getScenario(this.model.visionCode, raw);
        if(raw === WizConstants.BASE_SCENARIO) {
          result.push(WizTranslationManager.getInstance().translateKey('$.scen.main.$'));
        }
        if(!!scen) {
          result.push(scen.trsLabel);
        }
      });

    } else if (this.isFreeFilter) {
      result = this.tiFree?.wizValue?.split(' ') || [];
    } else if (this.isMeFilter) {
      result = this.cbMe?.wizChecked ? ['1'] : null;
    } else if (this.isBoolFilter) {
      result = this.cbMe?.wizChecked ? ['1'] : null;
    } else if(this.pkd.isChrono) {

      let myChron: ChronocodeVO;
      [...this.data.values].forEach((raw: string) => {
        myChron = this.model.chronocodeEngine.getChronocode(raw);
        result.push(myChron.trsLabel);
      });
      
    } else if (this.pkd.isFreedata) {

      const fdParts: string[] = this.wcio.cod.split(ViewData.CONTEXT_SEPARATOR); // on prend le code du FD
      // let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
      let fdv: FreedataValueVO; // le FDV porteur des infos

      if(this.useSubFilter) { // un sous-objet, on va prendre le label du args  
        let realField: string = this.model.widgetEngine.fdvfSplitter(this.wcio.fdvf)[0];  
        let subFreedataArg: FreedataArgsVO = this.argMap?.get(realField); // on utilise un subFD, c'est qui ?
        let subFreedataValueMap: Map<string, FreedataValueVO> = new Map(this.model.freedataEngine.getFreedataValuesByLevel(subFreedataArg.datas).map(item => [item.code, item]));

        [...this.data.values].forEach((raw: string) => {
          fdv = subFreedataValueMap.get(raw); 
          if(!!fdv) {
            result.push(fdv.trsLabel);
          }  
        });

      } else if(this.otherField && !this.useNonUniqueField) { // juste un autre champ que le code, MAIS UNIQUE !
        [...this.data.values].forEach((raw: string) => {
          fdv = this.freedata.getFreeDataValue(raw);
          if(fdv) {
            result.push(fdv.argsObjVO[this.otherField]);
          } else {
            console.log('no FDV ??', this);
          }
          
        });
      } else { // les valeurs brutes
        if(this.useNonUniqueField) {
          [...this.data.values].forEach((raw: string) => {
            let formated: string = this.model.formatEngine.applyFormat(raw, this.arg?.dataType || FIELD_KIND.STRING, null, null);
            // console.log('datakind ?',  raw, formated);
            result.push(formated);
          });

        } else {
          result = [...this.data.values];
        }
        
      }
    } else if (this.pkd.isMeasure) {
      
      if(this.pkd.datakind === FIELD_KIND.LIST) { // rendu spécifique pour les mesures de type liste
        this.model.listFieldEngine.generateFilterCollection(this.data); // on s'assure d'avoir les données nécessaires
        // TODO prendre les labels dans this.data.listMeasureCollection
        [...this.data.values].forEach((raw: string) => {
          if(this.data.listMeasureCollection?.has(raw)) {
            result.push(this.data.listMeasureCollection.get(raw).label);
          } else {
            result.push(raw);
          }
          
        });

      } else {
        let realFormat: string = this.wcio.fmt || this.pkd.measure.formatCode;

        [...this.data.values].forEach((raw: string) => {
          result.push(this.model.formatEngine.applyFormat(raw, this.datakind, realFormat, null));
        });
      }
    }
    // console.log("selectedAsLabel", this.pkd.fullCode, result);
    return result;
  }

  /**
   * retourne l'expression formatée
   */
  public get expAsLabel(): string {
    let result: string = ' ';

    const parts: string[] = this.data.regex.split(ViewData.KEY_SEPARATOR);
    const comp: ComparatorVO = ViewData.getInstance().getExtComparator(parts[0]);
    const formattedParts: string[] = [];
    if(!!comp) {
      switch(comp.nbParams) {
        case 0: 
          formattedParts.push(comp.fulltrsLabel);
        break;
        case 1: 
          formattedParts.push(comp.shortLabel);
          formattedParts.push(this.formatPart(parts[1]));
        break;
        case 2: 
          formattedParts.push(this.formatPart(parts[1]));
          formattedParts.push(comp.shortLabel);
          formattedParts.push(this.formatPart(parts[2]));
        break;
      }
    }

    result = formattedParts.join(' ');
    return result;
  }

  /**
   * retourne la part d'expression formatée
   * @param part string
   * @return le même formaté
   */
  private formatPart(part: string): string {
    let result: string = part;
    if (this.useSubFilter || this.otherField) { // un sous-FD, potentiellement one to Many
      if (!this.useSubFilter) { // autre champ, on prend son format
        const fdArg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(this.pkd.fullCode.split(ViewData.CONTEXT_SEPARATOR)[0], this.otherField);
        if (!!fdArg) {
          const dataKind: string = fdArg.dataType;
          const format: string = fdArg.format;  
          result = this.model.formatEngine.applyFormat(part, dataKind, format, null);
        }

      } else { // sous-fd, on prend son label
      } 
    } else {
      result = this.model.formatEngine.applyFormat(part, this.pkd.datakind, this.pkd.defaultFormat, null);
    }
    return result;
  }


  /**
   * affichage de la popUp de sélection du filtre
   */
  public showHidePop(): void {
    let popClass: any = PivotFilterExtendedPop; // rendu classique
    if(this.pkd.isScen) {
      popClass = PivotScenExtendedPop;// rendu mode scenario
    } 

    const filterPop: WizPopUp = new WizPopUp(
      popClass,
      false,
      false,
      null,
      popClass.width,
      popClass.height,
      null
    );

    let popDatas: filterPopData = {
      popReference: filterPop,
      filter: this.data,
      callback: this.backFromFilterPop.bind(this)
    };
    filterPop.datas = popDatas;

    const pos: DOMRect = this.block.nativeElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, filterPop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    filterPop.customPosition = targetPosition;

    if (PopUpManager.exist(filterPop)) {
      // suppression de l'instance existante
      filterPop.hide();
    }
    filterPop.show();
  }

  /**
   * retour de popUp
   * @param filter: IWidgetFilter
   */
  private backFromFilterPop(value: string): void {
    this.updateFilter();
  }

  /**
   * mise à jour du filtre sur retour de popUp ou clear
   */
  private updateFilter(dispatch:boolean = true): void {
    this._selected = null;
    
    if(this.isFreeFilter) {
      this.data.active = !!this.freeFilterValue;
      this.data.values = this.freeFilterValue ? new Set(this.freeFilterValue.split(' ')) : null;
    } else if(this.isMeFilter) {
      this.data.active = !!this.meFilterValue;
      this.data.values = this.meFilterValue ? new Set(['1']) : null;
    } else if(this.isBoolFilter) {
      this.data.active = this.boolFilterValue !== WIZ_BOOLEAN.UNKNOWN;
      switch(this.boolFilterValue) {
        case WIZ_BOOLEAN.TRUE: // checked
          this.data.values = new Set(['1']);
          break;
        case WIZ_BOOLEAN.FALSE: // unchecked
          this.data.values = new Set(['0']);
          break;
        case WIZ_BOOLEAN.UNKNOWN: // indeterminate
        default:
          this.data.values = null;
          break;
      }
    } else {
      this.data.active = this.data.values?.size > 0 || !!this.data.regex; 
    }

    if(dispatch) {
      WizEventManager.dispatchEvent(this.widget.elementRef, new AlkEvent(ALK_EVENT_TYPE.INNER_FILTER_UPDATE, this.data));
      setTimeout(() => {
       this.cdref.markForCheck();
      }, 0);
    }
  }

  /**
   * suppression d'un élément des zones de contenu
   *
   */
  public clearFilter(dispatch:boolean = true): void {
    this.data.values = null;
    this.data.regex = null;
    this.data.wcio.sel = null;

    // if(this.isFreeFilter) {
    //   this.tiFree.wizValue = null;
    //   this.freeFilterValue = null;
    // }
    // if(this.isMeFilter) {
    //   this.cbMe.wizChecked = false;
    //   this.meFilterValue = false;
    // }

    this.updateFilter(dispatch);
  }

  private typingTimer: any;
  private typingDelay = 400; // ms

  /** alimentation du filtre libre */
  public quickFilter(ff: string): void {
    clearTimeout(this.typingTimer);

    // if(!!ff?.trim()) {
    //  this.freeFilterValue = ff;
    // } else {
    //   this.freeFilterValue = null;
    // }
    
    this.typingTimer = setTimeout(() => {
      let str: string = this.tiFree.wizValue?.trim() || null;
      this.wcio.sel = str?.replaceAll(' ', ViewData.KEY_SEPARATOR) || null;
      // console.log('Saisie terminée :', this.freeFilterValue);
      this.updateFilter();
      // 👉 ton action ici
    }, this.typingDelay);
  }

  /**
   * contexte. Attention, non disponible dans la vue Freedata
   */
  public get context(): WidgetConfigurationItemObj {
    return  this.data?.wcio;
  }


  public get injectClass(): string {
    let myclass: string = 'voidme';
    if(!!this.context?.sty) {
      myclass = this.context?.sty;
    }
    return myclass;
  }

  /** alimentation du filtre libre */
  public quickMeFilter(e: WizEvent): void {
    if(this.cbMe.wizChecked) {
      this.wcio.sel = "1";
    } else {
      this.wcio.sel = null;
    }
    // this.meFilterValue = this.cbMe.wizChecked;
    this.updateFilter();
  }

  /** alimentation du filtre booléen */
  public quickBoolFilter(e: WizEvent): void {
    // console.log('quickBoolFilter', e);
    switch(this.cbBool.wizCheckState) {
      case WIZ_BOOLEAN.TRUE: // checked
        this.wcio.sel = "1";
        break;
      case WIZ_BOOLEAN.FALSE: // unchecked
        this.wcio.sel = "0";
        break;

      case WIZ_BOOLEAN.UNKNOWN: // indeterminate
      default:
        this.wcio.sel = null;
        break;
    }
    
    // if(this.cbBool.wizChecked) {
    //   this.wcio.sel = "1";
    // } else {
    //   this.wcio.sel = null;
    // }
    // this.meFilterValue = this.cbMe.wizChecked;
    this.updateFilter();
  }

}
